import { Registry } from '@react-registry'
import { stopAddingInlineProperties } from "./utils"
import { IPlugin } from "../../../../SuperChargedRte/utils/types"

export const withProperty: IPlugin = (editor) => {
    const { insertText } = editor

    editor.insertText = (text) => {
        try {
            stopAddingInlineProperties(editor)
            insertText(text)
        } catch (e) {
            insertText(text)
        }
    }
    return editor
}

Registry.register(withProperty, { id: 'withProperty', registry: 'v2.plugin' })
